import './NewWhatsAppButton.css';
const NewWhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/917989237393?text=Hi%20RoomBuddy!%20I'm%20looking%20for%20a%20rental%20home%20in%20Hyderabad."
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <svg viewBox="0 0 32 32" className="whatsapp-icon">
        <path
          fill="white"
          d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.118-1.958A15.923 15.923 0 0016.004 32C24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.302 22.602c-.39 1.1-1.932 2.014-3.166 2.28-.846.18-1.95.322-5.668-1.218-4.76-1.972-7.822-6.81-8.06-7.124-.228-.314-1.916-2.55-1.916-4.864 0-2.314 1.214-3.45 1.644-3.924.39-.43 1.026-.614 1.636-.614.198 0 .374.01.534.018.47.02.706.048 1.016.788.39.93 1.338 3.264 1.454 3.502.118.238.236.554.078.868-.148.324-.278.468-.516.74-.238.272-.464.48-.702.774-.218.258-.464.534-.196 1.004.268.46 1.192 1.966 2.558 3.184 1.758 1.566 3.24 2.052 3.7 2.28.46.228.73.19.998-.114.278-.314 1.186-1.38 1.504-1.854.308-.474.626-.394 1.054-.236.434.158 2.76 1.302 3.232 1.54.47.236.786.356.902.554.114.198.114 1.148-.276 2.24z"
        />
      </svg>
      <span className="whatsapp-tooltip">Chat with us!</span>
    </a>
  );
};
export default NewWhatsAppButton;